"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _legendClose = _interopRequireDefault(require("./legend-close"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledLegend = _styledComponents["default"].div.withConfig({
  displayName: "legend__StyledLegend",
  componentId: "sc-1uttvr1-0"
})(["position:absolute;top:0;right:0;transform:translate(-30px,20px);width:200px;border-radius:4px;padding:0 15px;max-height:200px;overflow:scroll;", ""], function (props) {
  return props.open && (0, _styledComponents.css)(["box-shadow:0 20px 30px 0 rgba(0,0,0,.1);border:1px solid rgba(26,28,34,.1);background:#FFF;"]);
});

var StyledLegendItem = _styledComponents["default"].ul.withConfig({
  displayName: "legend__StyledLegendItem",
  componentId: "sc-1uttvr1-1"
})(["list-style:none;padding:15px 0;"]);

var StyledLegendValue = _styledComponents["default"].li.withConfig({
  displayName: "legend__StyledLegendValue",
  componentId: "sc-1uttvr1-2"
})(["padding:2px 0;font-size:14px;color:#393f44;"]);

var StyledValueColor = _styledComponents["default"].div.withConfig({
  displayName: "legend__StyledValueColor",
  componentId: "sc-1uttvr1-3"
})(["display:inline-block;width:10px;height:10px;padding:0;border:1px solid rgba(26,28,34,.1);margin:0 10px 0 0;", ""], function (props) {
  return props.color && (0, _styledComponents.css)(["background:", ";"], props.color);
});

var StyledClosedLegend = _styledComponents["default"].span.withConfig({
  displayName: "legend__StyledClosedLegend",
  componentId: "sc-1uttvr1-4"
})(["display:flex;align-items:center;justify-content:flex-end;font-size:13px;color:#717171;cursor:pointer;"]);

var StyledClosedLegendInfo = _styledComponents["default"].span.withConfig({
  displayName: "legend__StyledClosedLegendInfo",
  componentId: "sc-1uttvr1-5"
})(["display:flex;align-items:center;font-size:12px;justify-content:center;width:15px;height:15px;margin-right:5px;border:1px solid hsla(0,0%,43.9%,.2);border-radius:100%;font-family:Georgia,serif;font-style:italic;color:#393f44;"]);

var StyledCloseButton = _styledComponents["default"].button.withConfig({
  displayName: "legend__StyledCloseButton",
  componentId: "sc-1uttvr1-6"
})(["position:absolute;top:10px;right:10px;width:10px;outline:none;background:none;border:none;cursor:pointer;svg{width:inherit;height:inherit;}"]);

var Legend = function Legend(_ref) {
  var widgetConfig = _ref.widgetConfig;

  var _ref2 = (0, _react.useState)(true),
      _ref3 = _slicedToArray(_ref2, 2),
      open = _ref3[0],
      setOpen = _ref3[1];

  return _react["default"].createElement(StyledLegend, {
    open: open
  }, open && _react["default"].createElement(StyledCloseButton, {
    type: "button",
    role: "button",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, _react["default"].createElement(_legendClose["default"], null)), !open && _react["default"].createElement(StyledClosedLegend, {
    onClick: function onClick() {
      return setOpen(true);
    }
  }, _react["default"].createElement(StyledClosedLegendInfo, null, "i"), "Legend"), open && widgetConfig.legend.map(function (leg, index) {
    return _react["default"].createElement(StyledLegendItem, {
      key: "legend-item-".concat(index)
    }, leg.values.map(function (legendValue) {
      return _react["default"].createElement(StyledLegendValue, {
        key: legendValue.label
      }, _react["default"].createElement(StyledValueColor, {
        color: legendValue.value
      }), legendValue.label);
    }));
  }));
};

var _default = Legend;
exports["default"] = _default;